import { Dialog, DialogContent, DialogContentText, DialogTitle } from '@mui/material';
import LockIcon from '@mui/icons-material/Lock';

export default function NotAuthorised({isOpen}) {
    return (
            <Dialog open={isOpen} className="cm_no_auth">
                <DialogTitle> <LockIcon className="cm_delete"/> Not Authorised  </DialogTitle>
                <DialogContent>
                    <DialogContentText>
                       You are not authorised to access this panel!
                    </DialogContentText>
                </DialogContent>
            </Dialog>
    );
}
